import { alpha, Stack, Typography, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC } from "react";
import { useFormatGoalAmount } from "web_myplann/Goals/Helpers/formatGoalAmount";
import type { ExtraContributionImpact } from "web_myplann/Goals/Types/ExtraContributionImpact";
import type { CurrencyEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	impact: ExtraContributionImpact;
	currencyCode?: CurrencyEnum;
};

export const WhatIfMoreViz: FC<Props> = ({ impact, currencyCode }) => {
	const theme = useTheme();
	const { t } = useResource();
	const formatAmount = useFormatGoalAmount();
	const accent = theme.palette.blue.main;

	return (
		<Stack pt={1.2} gap={1.2}>
			<Stack direction="row" alignItems="center" justifyContent="space-between">
				<Stack flex={1} alignItems="center">
					<Typography variant="hint">
						{t(Resources.Goals.Detail.WhatIf.More.originalGoal)}
					</Typography>
					<Typography variant="bodyStrong" tabular>
						{formatAmount(impact.savingsTarget, currencyCode)}
					</Typography>
				</Stack>
				<ChevronRight
					size={theme.iconSize.sm}
					color={theme.palette.grey[300]}
				/>
				<Stack flex={1} alignItems="center">
					<Typography variant="hint" color={accent}>
						{t(Resources.Goals.Detail.WhatIf.More.withIncrease)}
					</Typography>
					<Typography variant="bodyStrong" color={accent} tabular>
						{formatAmount(impact.newTargetTotal, currencyCode)}
					</Typography>
				</Stack>
			</Stack>
			<Stack
				alignSelf="center"
				px={1.2}
				py={0.6}
				bgcolor={alpha(accent, 0.1)}
				borderRadius={theme.radii.full}
			>
				<Typography variant="caption" color={accent} tabular>
					{t(Resources.Goals.Detail.WhatIf.More.extraToTarget, {
						amount: formatAmount(impact.extraTotal, currencyCode),
					})}
				</Typography>
			</Stack>
		</Stack>
	);
};
